import { render, staticRenderFns } from "./TextProvider.vue?vue&type=template&id=33d1b07b&"
import script from "./TextProvider.vue?vue&type=script&lang=ts&"
export * from "./TextProvider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports